<template>
  <div class='YBillTemplate'>
    <el-form :inline="true" :model="formInline" ref="rules" :label-width='`${ 200 / 192 }rem`'>
      <span v-for="(item, index) in formInline.fromList" :key="item.id">
        <div v-if="item.type === 'Title' || item.type === 'TooltipText' || item.type === 'Divider'">
          <component v-bind:is="item.type" :data='item'></component>
        </div>
        <div v-else-if="item.type === 'Form'">
          <FormFlow ref="FormFlow" :data='item' @change='changeFormFlow'></FormFlow>
        </div>
        <el-form-item
          class="from-item"
          v-else
          :label="`${item.controls.title}：`"
          :prop='`fromList.${index}.controls.value`'
          :rules="rules(item)"
          v-show="item.controls.show">
          <component v-bind:is="item.type" :data='item' Download @changeControls='changeControls'></component>
        </el-form-item>
        <br v-if="item.controls.br" />
      </span>
    </el-form>
  </div>
</template>

<script>
import deepClone from '@/shared/utils/deep-clone'
export default {
  name: 'YBillTemplate',

  props: {
    fromList: {
      type: Array,
      default () {
        return []
      }
    }
  },

  data () {
    return {
      formInline: {
        fromList: []
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.formInline.fromList = this.fromList
    },

    rules (item) {
      this.validate = (rule, value, callback) => {
        if (item.controls.verify && !new RegExp(item.controls.verify).test(value)) {
          callback(new Error('输入格式错误，请重新输入'))
        } else {
          callback()
        }
      }
      return [
        { required: true, message: `${item.controls.text ? item.controls.text : '请选择或填写该选项'}`, trigger: 'blur' },
        { validator: this.validate, trigger: 'blur' }
      ]
    },

    changeControls (val) {
      this.formInline.fromList.forEach(res => {
        if (res.id === val.id) {
          res.controls.value = val.controls.value
        }
      })
    },

    changeFormFlow (val) {
      this.formInline.fromList.forEach(res => {
        if (res.id === val.id) {
          res.controls.fromList = deepClone(val.controls.fromList)
        }
      })
    },

    submitForm () {
      const p1 = new Promise((resolve, reject) => {
        this.$refs.rules.validate(valid => {
          if (valid) resolve()
        })
      })

      const arr = this.$refs.FormFlow ? this.$refs.FormFlow[0].submitForm() : []
      arr.push(p1)
      return new Promise((resolve, reject) => {
        Promise.all(arr).then(() => {
          resolve(this.formInline.fromList)
        })
      })
    }
  }
}
</script>

<style lang='stylus' scoped>

</style>
